import React from "react"
import {CollectionAdd} from "components/backoffice/Media/Collection/CollectionAdd"

export const CollectionAddRoute = (props: any) => {

  return <div>
    <CollectionAdd />
  </div>
}